export class ExecuteForm { 
    id: string;
    code: string;
    name: string;
    appId: string;
    flowFormKey: string;
    formFormatId: string;
    formType: string;
    isDefault: boolean;
    terminal: string;
    actualParameters: Array<FormalParameter>;
    sysInit: number;
    remarks: string;
}

export class FormalParameter {
    code: string;
    name: string;
    valueType: string;
    value: string;
}
